var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',{attrs:{"placement":"top"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',[_vm._v("全屏")])]},proxy:true}])},[_c('a-icon',{staticClass:"settings-icon",attrs:{"type":"fullscreen"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }